import 'css-chunksrc/client/scenes/constraintEdition/styles.scss';export default {
  "constrainElement": "_constrainElement_19mid_1",
  "contextualMenu": "_contextualMenu_19mid_8",
  "row": "_row_19mid_14",
  "col": "_col_19mid_24",
  "text": "_text_19mid_31",
  "footer": "_footer_19mid_37",
  "buttons": "_buttons_19mid_46"
};